import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { CompanyApiService } from '@paymash/sdk/api/v2';
import {
  CompanyActions, CompanyApiActions,
  selectCompanyUuid,
  selectWebShopUrl
} from '@public-page/store/company';
import { GlobalService } from '@modules/core/services';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Injectable()
export class CompanyEffects {
  constructor(
    private actions$: Actions,
    private companyApiService: CompanyApiService,
    private globalService: GlobalService,
    private router: Router,
    private store: Store
  ) {}

  /* eslint-disable @typescript-eslint/no-unused-vars */

  /* eslint-disable @typescript-eslint/no-unused-vars */

  loadCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.load),
      switchMap(() => {
        if (this.globalService.hasCustomDomain) {
          return this.companyApiService.getCompanyByDomain(this.globalService.customDomain);
        }

        return this.companyApiService.getCompanyById(this.globalService.companyUuid);
      }),
      map((company) => CompanyApiActions.loadedSuccess({ company })),
      catchError(() => of(CompanyApiActions.loadedFailure()))
    );
  });

  redirectToCompanyPage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.redirectToCompanyPage),
        concatLatestFrom(() => this.store.select(selectCompanyUuid)),
        tap(([action, companyUuid]) => {
          const path = this.globalService.hasCustomDomain ? ['public'] : [companyUuid, 'public'];

          this.router.navigate(path, {
            replaceUrl: true,
          });
        })
      );
    },
    { dispatch: false }
  );

  redirectToOnlineShop$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.redirectToOnlineShop),
        concatLatestFrom(() => this.store.select(selectWebShopUrl)),
        tap(([action, webShopUrl]) => {
          if (webShopUrl) {
            window.location.href = webShopUrl;
          }
        })
      );
    },
    { dispatch: false }
  );
}
